// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_BuscarOcorrenciasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscarOcorrencias() /ocorrencias/buscarOcorrencias
 * Returns array of occurrences for a given owner and ownerID.
 *
 * Row shape: see Ocorrencias_BuscarOcorrenciasRow.
 */
import type { Ocorrencias_BuscarOcorrenciasRow } from './Ocorrencias_BuscarOcorrenciasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Ocorrencias_BuscarOcorrenciasResponseDados = Ocorrencias_BuscarOcorrenciasRow[];

export type Ocorrencias_BuscarOcorrenciasResponse = ApiResponse<Ocorrencias_BuscarOcorrenciasResponseDados>;

registerResponseContract('Ocorrencias_BuscarOcorrenciasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      Content:   { type: 'string',  required: false },
      User:      { type: 'string',  required: false },
      CreatedAt: { type: 'string',  required: false },
    },
  },
})
